export const contribution_member_frontend_version = '1.0.2';
